var ServiceManager = {
    services: {},
    addService(component, serviceName, serviceObject) {
        if (!component) return;
        if (!serviceName) return;

        let appId = this.getAppId(component);
        if (!appId) {
            console.warn("Could not determine Vue application Id");
        }

        if (!this.services.hasOwnProperty(appId)) {
            this.services[appId] = {};
        }
        let container = this.services[appId];
        container[serviceName] = serviceObject;
    },
    getService(component, serviceName) {
        if (!component) return;
        if (!serviceName) return;

        let appId = this.getAppId(component);
        if (!appId) {
            console.warn("Could not determine Vue application Id");
        }
        if (!this.services.hasOwnProperty(appId)) return null;
        if (!this.services[appId].hasOwnProperty(serviceName)) return null;
        return this.services[appId][serviceName];
    },
    getAppId(component) {
        if (!component) return 0;
        if (!component.$root) return "UnknownComponentId";
        return component.$root.uniqueId || component.$root._name;
    }

};

export default ServiceManager;